import { EmbeddedMessage, IN_APP, PUSH } from 'constants/messageMediums';
import {
  SelectiveEmbedded,
  SelectiveInApp,
  SelectivePush,
  SelectiveTargetingEmptyState,
} from 'modules/workflowNodeEditors/components/sendNodeEditors/BaseSendEditor/DeliverySection/SelectiveTargeting';
import { useController } from 'react-hook-form';

export const ControlledSelectiveTargeting = ({
  name,
  defaultValue = [],
  messageMedium,
  ...rest
}: any) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue,
  });

  if (messageMedium === PUSH) {
    return <SelectivePush {...rest} name={name} mobileAppIds={value} setMobileAppIds={onChange} />;
  } else if (messageMedium === IN_APP) {
    return <SelectiveInApp {...rest} name={name} mobileAppIds={value} setMobileAppIds={onChange} />;
  } else if (messageMedium === EmbeddedMessage) {
    return (
      <SelectiveEmbedded {...rest} name={name} mobileAppIds={value} setMobileAppIds={onChange} />
    );
  } else return null;
};

export { SelectiveTargetingEmptyState };
